enum OrderSkipReason {
  NonSyncOps = 'skip-non-sync-ops',
  ProdI9n = 'skip-prod-i9n',
  OfflineDemoMode = 'offline-demo-mode',
  UnsentOrder = 'skip-unsent-order',
  UnvalidatedOrder = 'skip-unvalidated-order',
  UsesOnPremApi = 'skip-uses-on-prem-api',
}

export { OrderSkipReason };
